import React, { useState } from 'react';
import { Clipboard, Bug } from 'lucide-react';
import PricingControls from './PricingControls';
import OrderManagementControls from './OrderManagementControls';
import KioskManagementControls from './KioskManagementControls';
import DownloadGalleryControls from './DownloadGalleryControls';
import BugReportModal from '../Modals/BugReportModal';

const ControlPanel = ({
  onShowGunPriceModal,
  onShowPhotoPriceModal,
  priceLoading,
  onShowOrderHistory,
  onDeleteAllOrders,
  orderCount,
  isDeletingAll,
  onDeleteAllImages,
  onRefreshPages,
  processing,
  onShowSubmissionViewer,
  listView,
  onToggleListView,
  onDownloadGalleryImages,
  onShowNamesList
}) => {
  const [showBugReportModal, setShowBugReportModal] = useState(false);

  return (
    <>
      <div className="control-panel">
        <PricingControls
          onShowGunPriceModal={onShowGunPriceModal}
          onShowPhotoPriceModal={onShowPhotoPriceModal}
          priceLoading={priceLoading}
        />

        <OrderManagementControls
          onShowOrderHistory={onShowOrderHistory}
          onDeleteAllOrders={onDeleteAllOrders}
          orderCount={orderCount}
          isDeletingAll={isDeletingAll}
        />

        <KioskManagementControls
          onDeleteAllImages={onDeleteAllImages}
          onRefreshPages={onRefreshPages}
          processing={processing}
          onShowNamesList={onShowNamesList}
        />

        <DownloadGalleryControls onDownloadImages={onDownloadGalleryImages} />

        <div className="dropdown-container">
          <button
            className="btn"
            onClick={onShowSubmissionViewer}
          >
            <Clipboard size={16} />
            View Waivers
          </button>
        </div>

        <div className="dropdown-container">
          <button
            className="btn"
            onClick={() => setShowBugReportModal(true)}
            style={{ backgroundColor: '#dc3545', color: 'white' }}
          >
            <Bug size={16} />
            Report Bug
          </button>
        </div>
      </div>

      <BugReportModal
        show={showBugReportModal}
        onClose={() => setShowBugReportModal(false)}
      />
    </>
  );
};

export default ControlPanel;
